// Angular and RJX Imports
// =========================================================
import { Component, type OnInit } from '@angular/core'
// Prime NG Imports
// =========================================================
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog'
import { CustomGridOptions } from 'src/app/05_ag-grid-configs/02_global-settings/grid-options'
import { RecoBuyQtySubmit_GenerateGridData } from 'src/app/05_ag-grid-configs/04_generate-colDefs/reco-buy-qty-submit-colDefs'
import $recoBuyQtySubmitJSON from '../../../05_ag-grid-configs/01_json-grid-configs/reco-buy-qty/colDefs-reco-buy-qty-submit.json'
import { type RowSelectedEvent, type GridApi, type GridReadyEvent, type RowNode } from 'ag-grid-community'
import { type FormArray, type FormGroup } from '@angular/forms'

// Custom Imports
// =========================================================

export interface SubmitRow {
  row_id: string
  style_color: string
  channel: string
  size_range: string
  reco_qty: string
  deliveries: any
  deliveries_data: Delivery[]
}

export interface Delivery {
  row_id: number
  need_date: string
  delivery_type: string
  unit_qty: number
}

@Component({
  standalone: false,
  selector: 'app-reco-buy-qty-submit-modal',
  templateUrl: './reco-buy-qty-submit-modal.component.html',
  styleUrls: ['./reco-buy-qty-submit-modal.component.scss']
})
export class RecoBuyQtySubmitModalComponent implements OnInit {
  loading: boolean = false

  recoBuyQtySubmit = $recoBuyQtySubmitJSON

  modalTitle = 'Submit Selected to Review Orders'

  rowData: SubmitRow[]
  columnDefs = []
  gridApi: GridApi
  gridOptions = {
    ...CustomGridOptions,
    onSelectionChanged: (event: RowSelectedEvent) => this.onSelectionChanged(event),
    context: {
      componentParent: this,
      onDeliveryFormChange: (deliveries: Delivery[], rowHasErrors: boolean, row_id: string) =>
        this.onDeliveryFormChange(deliveries, rowHasErrors, row_id)
    },
    getRowId: (data: RowNode) => data.data.row_id,
    onGridReady: (event: GridReadyEvent) => this.onGridReady(event),
    autoSizeStrategy: {
      type: 'fitCellContents'
    }
  }

  selectedRows: SubmitRow[] = []

  deliveryFormErrors = true
  deliveryFormErrorsByRow = {}

  constructor (
    private readonly ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public dialogService: DialogService
  ) {
    console.log('---> Reco Buy Qty Submit Modal: ', config.data)
    this.rowData = config.data
    this.rowData.forEach(row => {
      this.deliveryFormErrorsByRow[row.row_id] = true // all rows will be blank, so none of them are valid yet
    })
  }

  ngOnInit (): void {}

  onGridReady (event: GridReadyEvent) {
    console.log('submit modal grid ready')
    this.gridApi = event.api
    RecoBuyQtySubmit_GenerateGridData({ mainColDefs: this.recoBuyQtySubmit[0] as any }).then(data => {
      console.log('got col data back', data)
      this.columnDefs = data.mainColDefs
      this.gridApi.autoSizeColumns(['style_color'])
      this.gridApi.selectAll()
    })
  }

  onSelectionChanged (event: RowSelectedEvent) {
    this.selectedRows = this.gridApi.getSelectedNodes().map(row => row.data)
    this.recalculateDeliveryFormErrors()
  }

  onDeliveryFormChange (deliveries: Delivery[], rowHasErrors: boolean, row_id: string) {
    console.log('delivery form change', deliveries, rowHasErrors, row_id)
    const rowNode = this.gridApi.getRowNode(row_id)
    rowNode.updateData({ ...rowNode.data, deliveries_data: deliveries })
    this.rowData.forEach(row => {
      if (row.row_id === row_id) row['deliveries_data'] = deliveries
    })
    this.deliveryFormErrorsByRow[row_id] = rowHasErrors
    this.recalculateDeliveryFormErrors()
    console.log('updated row', row_id, rowHasErrors)
  }

  recalculateDeliveryFormErrors () {
    let errors = false
    console.log('recalculating errors')
    this.selectedRows.forEach(row => {
      console.log('for row', row)
      console.log('delivery form errors by row', this.deliveryFormErrorsByRow)
      if (this.deliveryFormErrorsByRow[row.row_id]) {
        errors = true
      }
    })
    console.log('final errors', errors)
    this.deliveryFormErrors = errors
  }

  onSubmit () {
    this.ref.close(
      this.rowData.reduce(
        (x, y) =>
          x.concat(
            y.deliveries_data.map(d => {
              return { ...d, channel: y.channel }
            })
          ),
        []
      )
    )
  }

  close () {
    this.ref.close()
  }
}
